/**
 *
 * SigningModal
 *
 */
import PropTypes from 'prop-types';

import React, { useState } from 'react';
import { Modal, ModalBody, ModalHeader } from 'reactstrap';

import useIsMobile from 'hooks/isMobile.ts';

import './index.css';

const SigningModal = (props) => {
	const { isOpen, toggle, siteUrl, onOpenInNewTab, popupBlocked, pollTimedOut } =
		props;
	const isMobile = useIsMobile();
	const [expanded, setExpanded] = useState(false);
	// The escape hatch only makes sense where the container wires the new-tab
	// handler (intake, which also owns the completion polling). The other
	// SigningModal consumers pass no handler and get no fallback UI.
	const hasFallback = typeof onOpenInNewTab === 'function';
	// A status the patient must see can arrive with zero interaction (the poll
	// ceiling), so statuses force the section open regardless of the toggle.
	const showFallback = expanded || popupBlocked || pollTimedOut;

	return (
		<div>
			<Modal
				isOpen={isOpen}
				toggle={toggle}
				className={`${isMobile && 'modal-mobile'}`}
				size={isMobile ? 'auto' : 'xl'}
			>
				<ModalHeader toggle={toggle}>
					Mind Therapy Clinic Client Information and Agreement
				</ModalHeader>
				<ModalBody>
					<div className="demo-iframe-holder ">
						<iframe title="Signing" src={siteUrl} />
					</div>
					{hasFallback && (
						<div className="signing-fallback">
							<button
								type="button"
								className="btn btn-link signing-fallback-toggle"
								aria-expanded={showFallback}
								onClick={() => setExpanded((prev) => !prev)}
							>
								Having trouble seeing the document?
							</button>
							{showFallback && (
								<>
									<p className="signing-fallback-help">
										If the signing window above is blank or won&apos;t load,
										open it in a new browser tab to finish. Once you&apos;ve
										signed, you&apos;ll be taken to your dashboard
										automatically.
									</p>
									<div className="signing-fallback-actions">
										<button
											type="button"
											className="btn btn-primary btn-lg btn-color text-uppercase font-13"
											onClick={onOpenInNewTab}
										>
											Open signing in a new tab
										</button>
									</div>
									{popupBlocked && (
										<p className="signing-fallback-blocked">
											Your browser blocked the new signing tab. Please allow
											pop-ups for this site and try again, or use this direct
											link:{' '}
											<a
												href={siteUrl}
												target="_blank"
												rel="noopener noreferrer"
											>
												open the signing page
											</a>
											.
										</p>
									)}
									{pollTimedOut && (
										<p className="signing-fallback-timeout">
											We&apos;re still waiting on your completed signature. If
											you&apos;ve already signed, refresh this page — and if
											it still doesn&apos;t go through, please contact
											support.
										</p>
									)}
								</>
							)}
						</div>
					)}
				</ModalBody>
			</Modal>
		</div>
	);
};

SigningModal.propTypes = {
	isOpen: PropTypes.bool.isRequired,
	toggle: PropTypes.func.isRequired,
	siteUrl: PropTypes.string.isRequired,
	onOpenInNewTab: PropTypes.func,
	popupBlocked: PropTypes.bool,
	pollTimedOut: PropTypes.bool,
};

SigningModal.defaultProps = {
	onOpenInNewTab: null,
	popupBlocked: false,
	pollTimedOut: false,
};

export default SigningModal;
